import moment from 'moment';
import { EditProfile } from '_components/Profile/EditProfile';
import { preventNegativeValueInDocs, getProgressStatusText } from '_helpers/helpers';
import { dateTimeConstants } from '_constants';
import DatePicker from 'react-datepicker';
import { Controller } from 'react-hook-form';
import PropTypes from "prop-types";

export default function NationalCrewContract({ profileData, refetchUser, currentUserPermissions, authUser }) {
  return (
    <div className='mb-2'>
    <div>
        <div className='qualifications_header-tab'>
          <h3>National Crew Contract</h3>
        </div>
      </div>
      <div className='qualifications_header-tab'>
        <div className='qualification-row'>
          <label>FFT1</label>
          <div className='input-like-box'>
            <div className='input-like-box_field'>
              <span>
                {profileData.ncc_fft1_status
                  ? getProgressStatusText(
                      profileData.ncc_fft1_status,
                      profileData.ncc_fft1_date,
                    )
                  : '-'}
              </span>
            </div>

            <EditProfile
              label='NCC FFT1'
              profileData={profileData}
              refetchUser={refetchUser}
              authUser={authUser}
              hasPermissionRequiredToEditOwn={false}
              hasPermissionToEditOthers={currentUserPermissions.includes(
                'Manage Expiry/Assigned Dates',
              )}
            >
              {(register, errors, setValue, control) => (
                <>
                  <label>Status</label>
                  <select
                    {...register('ncc_fft1_status', {
                      required: 'Status is required',
                    })}
                    defaultValue={profileData.ncc_fft1_status}
                    className={
                      errors.ncc_fft1_status && 'profile-form-field-error'
                    }
                  >
                    <option value=''>Select Status</option>
                    <option value='1'>Sent</option>
                    <option value='2'>Approved</option>
                  </select>
                  {errors.ncc_fft1_status && (
                    <p className='error-message'>
                      {errors.ncc_fft1_status.message}
                    </p>
                  )}

                  <label>Date</label>
                  <Controller
                    name='ncc_fft1_date'
                    control={control}
                    defaultValue={
                      profileData.ncc_fft1_date
                        ? moment(profileData.ncc_fft1_date).format(
                            dateTimeConstants.DATE_FORMAT,
                          )
                        : null
                    }
                    rules={{
                      required: 'Date is required',
                    }}
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <DatePicker
                        selected={value ? moment(value) : ''}
                        onChange={(date) =>
                          onChange(
                            date &&
                              !date.endOf('day').isAfter(moment().endOf('day'))
                              ? date.format(dateTimeConstants.DATE_FORMAT)
                              : '',
                          )
                        }
                        customInput={<input inputMode='none' />}
                        maxDate={moment()}
                        showMonthDropdown
                        showYearDropdown
                        placeholderText='Select Date'
                        className={error ? 'profile-form-field-error' : ''}
                        dateFormat={dateTimeConstants.DATE_FORMAT}
                        showPopperArrow={false}
                      />
                    )}
                  />
                  {errors.ncc_fft1_date && (
                    <p className='error-message'>
                      {errors.ncc_fft1_date.message}
                    </p>
                  )}
                </>
              )}
            </EditProfile>
          </div>
        </div>

        <div className='qualification-row'>
          <label>ICT5</label>
          <div className='input-like-box'>
            <div className='input-like-box_field'>
              <span>
                {profileData.ncc_ict5_status
                  ? getProgressStatusText(
                      profileData.ncc_ict5_status,
                      profileData.ncc_ict5_date,
                    )
                  : '-'}
              </span>
            </div>
            <EditProfile
              label='ICT5'
              profileData={profileData}
              refetchUser={refetchUser}
              authUser={authUser}
              hasPermissionRequiredToEditOwn={false}
              hasPermissionToEditOthers={currentUserPermissions.includes(
                'Manage Expiry/Assigned Dates',
              )}
            >
              {(register, errors, setValue, control) => (
                <>
                  <label>Status</label>
                  <select
                    {...register('ncc_ict5_status', {
                      required: 'Status is required',
                    })}
                    defaultValue={profileData.ncc_ict5_status}
                    className={
                      errors.ncc_ict5_status && 'profile-form-field-error'
                    }
                  >
                    <option value=''>Select Status</option>
                    <option value='1'>Sent</option>
                    <option value='2'>Approved</option>
                  </select>
                  {errors.ncc_ict5_status && (
                    <p className='error-message'>
                      {errors.ncc_ict5_status.message}
                    </p>
                  )}

                  <label>Date</label>
                  <Controller
                    name='ncc_ict5_date'
                    control={control}
                    defaultValue={
                      profileData.ncc_ict5_date
                        ? moment(profileData.ncc_ict5_date).format(
                            dateTimeConstants.DATE_FORMAT,
                          )
                        : null
                    }
                    rules={{
                      required: 'Date is required',
                    }}
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <DatePicker
                        selected={value ? moment(value) : ''}
                        onChange={(date) =>
                          onChange(
                            date &&
                              !date.endOf('day').isAfter(moment().endOf('day'))
                              ? date.format(dateTimeConstants.DATE_FORMAT)
                              : '',
                          )
                        }
                        customInput={<input inputMode='none' />}
                        maxDate={moment()}
                        showMonthDropdown
                        showYearDropdown
                        placeholderText='Select Date'
                        className={error ? 'profile-form-field-error' : ''}
                        dateFormat={dateTimeConstants.DATE_FORMAT}
                        showPopperArrow={false}
                      />
                    )}
                  />
                  {errors.ncc_ict5_date && (
                    <p className='error-message'>
                      {errors.ncc_ict5_date.message}
                    </p>
                  )}
                </>
              )}
            </EditProfile>
          </div>
        </div>
        <div className='qualification-row'>
          <label>CRWB</label>
          <div className='input-like-box'>
            <div className='input-like-box_field'>
              <span>
                {profileData.ncc_crwb_status
                  ? getProgressStatusText(
                      profileData.ncc_crwb_status,
                      profileData.ncc_crwb_date,
                    )
                  : '-'}
              </span>
            </div>
            <EditProfile
              label='NCC CRWB'
              profileData={profileData}
              refetchUser={refetchUser}
              authUser={authUser}
              hasPermissionRequiredToEditOwn={false}
              hasPermissionToEditOthers={currentUserPermissions.includes(
                'Manage Expiry/Assigned Dates',
              )}
            >
              {(register, errors, setValue, control) => (
                <>
                  <label>Status</label>
                  <select
                    {...register('ncc_crwb_status', {
                      required: 'Status is required',
                    })}
                    defaultValue={profileData.ncc_crwb_status}
                    className={
                      errors.ncc_crwb_status && 'profile-form-field-error'
                    }
                  >
                    <option value=''>Select Status</option>
                    <option value='1'>Sent</option>
                    <option value='2'>Approved</option>
                  </select>
                  {errors.ncc_crwb_status && (
                    <p className='error-message'>
                      {errors.ncc_crwb_status.message}
                    </p>
                  )}

                  <label>Date</label>
                  <Controller
                    name='ncc_crwb_date'
                    control={control}
                    defaultValue={
                      profileData.ncc_crwb_date
                        ? moment(profileData.ncc_crwb_date).format(
                            dateTimeConstants.DATE_FORMAT,
                          )
                        : null
                    }
                    rules={{
                      required: 'Date is required',
                    }}
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <DatePicker
                        selected={value ? moment(value) : ''}
                        onChange={(date) =>
                          onChange(
                            date &&
                              !date.endOf('day').isAfter(moment().endOf('day'))
                              ? date.format(dateTimeConstants.DATE_FORMAT)
                              : '',
                          )
                        }
                        customInput={<input inputMode='none' />}
                        maxDate={moment()}
                        showMonthDropdown
                        showYearDropdown
                        placeholderText='Select Date'
                        className={error ? 'profile-form-field-error' : ''}
                        dateFormat={dateTimeConstants.DATE_FORMAT}
                        showPopperArrow={false}
                      />
                    )}
                  />
                  {errors.ncc_crwb_date && (
                    <p className='error-message'>
                      {errors.ncc_crwb_date.message}
                    </p>
                  )}
                </>
              )}
            </EditProfile>
          </div>
        </div>
      </div>
    </div>
  );
}

NationalCrewContract.propTypes = {
  profileData: PropTypes.object.isRequired,
  refetchUser: PropTypes.func,
  currentUserPermissions: PropTypes.array,
  authUser: PropTypes.any,
};